import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
// A remotely loaded image. Retries loading indefinitely until successful.
export var RemoteLoadedImage = function (_a) {
    var src = _a.src, className = _a.className, alt = _a.alt;
    var imageRef = useRef(null);
    var onError = function () {
        console.error("Error downloading image with url '" + src + "'.");
        setTimeout(function () {
            if (imageRef.current) {
                // Trigger a retry by setting the src directly.
                imageRef.current.src = src;
            }
        }, 1000);
    };
    var onLoad = function () {
        console.log(src + " downloaded.");
    };
    return (_jsx("img", { src: src, className: className, onError: onError, onLoad: onLoad, ref: imageRef, alt: alt, crossOrigin: "anonymous" }));
};
